// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ReplyIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Reply/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M3 10h10a8 8 0 0 1 8 8v2M3 10l6 6m-6-6 6-6"
}));
export default ReplyIcon;